module.exports = __webpack_public_path__ + "img/logo.47726194.png";